const genericGetters = {
    activeOnboardingToolTip (state){
        return state.active_onboarding_tooltip;
    }
}

export default genericGetters